export default __webpack_public_path__ + "static/media/miguel-lopes-35.7ad11666.jpg";